import { useTranslations } from '@npco/utils-translations'
import { Box, NewBadge } from '@npco/zeller-design-system'
import { PointsSection } from 'features/StartupModals/SetupFlow/SetupFlowModal/pages/TapToPayStage/TapToPayStage/PointsSection'

import { translationsShared } from 'translations'

import {
  ScrollableContent,
  Subtitle,
  Title,
} from '../../../SetupFlowModal.styled'
import { setupFlowTapToPayStageTranslations } from '../TapToPayStage.i18n'

export const MainContent = () => {
  const t = useTranslations(setupFlowTapToPayStageTranslations)
  const tShared = useTranslations(translationsShared)

  return (
    <>
      <Box position="relative" display={{ _: 'block', LG: 'none' }}>
        <Box position="relative" top={{ _: '-38px', XS: '-42px' }}>
          <NewBadge text={tShared('new')} />
        </Box>
      </Box>
      <ScrollableContent data-testid="setup-flow-tap-to-app-stage">
        <Box display={{ _: 'none', LG: 'block' }}>
          <NewBadge text={tShared('new')} />
        </Box>
        <Title>{t('title')}</Title>
        <Subtitle>{t('description')}</Subtitle>
        <PointsSection />
      </ScrollableContent>
    </>
  )
}
